import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { JsonObjectFactoryService } from '../../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class Form1125aService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  save1125ADetails(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any
  ): Observable<any> {
    if (!data?.rowData) return of({ callSuccess: '0', errorMessage: 'Row data is required.' });
    if (data.rowData.SCENARIO !== undefined && data.rowData.SCENARIO !== data.rowData.SCENARIO_KEY) {
      return of({ callSuccess: '0', errorMessage: 'Selected Scenario is Locked, please verify and update the amount.' });
    }
    const clobData = [data.rowData];
    const clobSetting = { tax_year: globalService?.globalParams?.tax_year };
    const params: any = {
      process_name: 'F1125A_EDIT_SAVE',
      tax_year: globalService?.globalParams?.tax_year,
      scenario: globalService?.globalParams?.scenario,
      jcd_key: globalService?.globalParams?.jcd_key,
      clob_data: JSON.stringify(clobData),
      clob_setting: JSON.stringify(clobSetting)
    };
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=d58wez`,
      params,
      globalService,
      filterParams
    );
  }
}
